<!-- static content data from lang: chat -->
<template>
  <div class="container h-100" v-loading="loading">
    <b-card class="chat-module">
      <b-container fluid>
        <b-row>
          <b-col lg="4" class="users-list-section" v-if="frompath == 'home'">
            <b-card no-body>
              <template #header>
                <b-form-input v-model="search" type="text" :placeholder="lang.label.searchName"></b-form-input>
              </template>
              <b-card-body>
                <b-list-group class="users-list">
                  <template v-for="(chat, index) in userchats">
                    <b-list-group-item :active="chat.id == activeId" button :key="index" @click="
                      userDetail(
                        chat.id,
                        chat.pharmacyName,
                        chat.formReferenceId,
                        chat.formsManagementId,
                        chat.formId,
                        chat.pharmacyId
                      )
                      ">
                      <div class="d-flex justify-content-between">
                        <div class="user-detail">
                          <h5 class="user-naming">
                            {{ chat.pharmacyName == undefined ? " " : chat.pharmacyName }}
                          </h5>
                        </div>
                        <time class="period">{{ createdDate(chat.createdAt) }}</time>
                      </div>
                      <p class="text-truncate mb-0">{{ chat.message }}</p>
                    </b-list-group-item>
                  </template>
                </b-list-group>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col :lg="frompath == 'home' ? '8' : '12'" class="message-section">
            <b-card no-body>
              <template #header>
                <b-media>
                  <h5 class="chat-user-header">{{ name !== "undefined" ? name : "" }}</h5>
                </b-media>
              </template>
              <b-card-body id="chat">
                <div v-observe-visibility="visibilityChanged"></div>
                <b-list-group class="messaging">
                  <template v-for="(chat, chatIndex) in detailedChats">
                    <b-list-group-item :class="chat.userType == 'pharmacists' ? '' : 'me'" :key="chatIndex">
                      <div class="time-period" v-bind:key="chatIndex">
                        <span v-if="chat.date !== null">{{ getDate(chat.createdAt, chat.date) }}</span>
                      </div>
                      <b-media>
                        <div class="message-div">
                          <div class="chat-message">
                            <span class="chat-text" v-if="chat.message">{{
                              chat.message
                              }}</span>
                            <div class="uploaded-image" v-if="chat.image">
                              <template
                                v-if="(chat.image.toLowerCase().endsWith('.jpeg') || (chat.image.toLowerCase().endsWith('.png') || (chat.image.toLowerCase().endsWith('.jpg'))))">
                                <div class="image-wrap" @click="showImg(chat.image)">
                                  <!-- <img :src="getImgUrl('signature.png')" alt="" /> -->
                                  <img :src="chat.image" alt="" />
                                </div>
                              </template>
                              <template v-else-if="(chat.image.toLowerCase().endsWith('.pdf'))">
                                <div>
                                  <!-- <img :src="getImgUrl('signature.png')" alt="" /> -->
                                  <a :href="chat.image" alt="" target="_blank"><u>{{
                                    chat.image.replace("https://payscript-production.s3.af-south-1.amazonaws.com/uploads/chat/",
                                      "") }}</u></a>
                                </div>
                              </template>

                            </div>
                            <span class="chat-time">{{ timeFormat(chat.time) }}</span>
                          </div>
                        </div>
                      </b-media>
                    </b-list-group-item>
                  </template>
                </b-list-group>
              </b-card-body>
              <template #footer>
                <b-input-group>
                  <b-input-group-prepend>
                    <!-- <b-button variant="outline-info">
                        <i class="sprite ic-attachment"></i>
                      </b-button> -->
                    <div class="custom-file attachment-file">
                      <input type="file" class="custom-file-input" id="attachment" @change="onFileChange"
                        accept="image/jpeg,image/gif,image/png,application/pdf" :disabled="fdisabled"
                        @keydown.enter.prevent="onSubmit" />
                      <label class="custom-file-label" for="attachment">
                        <i class="sprite ic-attachment"></i>
                      </label>
                    </div>
                  </b-input-group-prepend>

                  <b-form-textarea v-model="text" type="text" :placeholder="lang.label.enterMessage" no-resize
                    :disabled="tdisabeld" @keydown.enter="onSubmit"></b-form-textarea>

                  <b-input-group-append>
                    <b-button variant="outline-secondary" @click="onSubmit" :disabled="bdisabled">
                      <i class="sprite ic-send"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
    <b-modal size="xl" id="showImage" scrollable ref="showImage" hide-footer>
      <div class="chat-image">
        <img :src="image" alt="">
      </div>
    </b-modal>
  </div>
</template>

<script>
// import Vue from "vue";
import jsondata from "../assets/json/data.json";
import ChatWindow from "vue-advanced-chat";
import "vue-advanced-chat/dist/vue-advanced-chat.css";
import moment from "moment";
import { mapGetters } from "vuex";
import { eventBus } from "../main.js";
import Vue from "vue";
import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);
export default {
  components: {
    ChatWindow,
  },
  computed: {
    ...mapGetters({
      name: "name",
      loading: "loading",
      receivedMessage: "receivedMessage",
      received: "received",
      groupRequestDetails: "groupRequestDetails",
      frompath: "frompath",
      pdetails: "pdetails",
    }),
    userchats() {
      if (this.search) {
        var search = this.search
        return this.chats.filter((item, index) => {
          return (
            item.pharmacyName.toLowerCase().startsWith(this.search) ||
            item.pharmacyName.toUpperCase().startsWith(this.search) ||
            item.pharmacyName.substring(0, 1).toUpperCase().startsWith(search) + item.pharmacyName.substring(1).toLowerCase().startsWith(search.substring(1))
          );
        });
      } else {
        return this.chats;
      }
    },
  },
  data() {
    return {
      data: jsondata,
      lang: this.$lang.chat,
      search: "",
      rooms: [],
      messages: [],
      currentUserId: 1,
      pageNo: 1,
      searchUser: "",
      chats: [],
      detailedChats: [],
      bdisabled: true,
      fdisabled: false,
      tdisabeld: false,
      text: "",
      image: null, // imageSrc: [],
      lastScroll: 0,
      pageNum: null,
      image: '',
      noData: false,
      activeId: null,
    };
  },
  created() {
    window.addEventListener("scroll", this.scrollFunction);
  },
  mounted() {
    let self = this;
    self.initialChatLoad(true);
  },
  methods: {
    showImg(img) {
      this.image = img;
      this.$refs['showImage'].show()
    },
    getDate(value, dateValue) {
      let someDate = new Date(value);
      let today = new Date();
      if (
        someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
      ) {
        return 'Today';
      } else if (someDate.getDate() == (today.getDate() - 1) &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
      ) {
        return 'Yesterday';
      } else {
        return dateValue;
      }
    },
    timeFormat(dateFormat) {
      let t = dateFormat.substr(0, 2);
      if (t >= 0 && t < 12) {
        return dateFormat.substr(0, 5) + " AM";
      } else {
        return dateFormat.substr(0, 5) + " PM";
      }
    },
    initialChatLoad(is_load) {
      let self = this;
      let data = {
        pageNo: self.pageNo,
        search: self.searchUser,
      };

      if (Object.keys(self.groupRequestDetails).length > 0) {
        self.userDetail(
          self.pdetails.id,
          self.pdetails.name,
          self.pdetails.referenceid,
          self.pdetails.managementid,
          self.pdetails.formid,
          self.pdetails.pharmacyid
        );
      } else {
        data.is_load = is_load;
        self.$store.dispatch("chatConversationList", data).then((response) => {
          if (response.status == 200) {
            let responseData = response.data;
            self.chats = responseData;
            if (Object.keys(self.pdetails).length == 0) {
              self.userDetail(
                self.chats[0].id,
                self.chats[0].doctorName,
                self.chats[0].formReferenceId,
                self.chats[0].formsManagementId,
                self.chats[0].formId,
                self.chats[0].pharmacyId
              );
            }
          }
        });
      }
    },
    visibilityChanged(isVisible, entry) {
      if (entry.intersectionRatio == 1 && !this.noData && Object.keys(this.pdetails).length > 0) {
        this.userDetail(
          this.pdetails.id,
          this.pdetails.name,
          this.pdetails.referenceid,
          this.pdetails.managementid,
          this.pdetails.formid,
          this.pdetails.pharmacyid,
          this.pageNum
        );
      }
    },
    createdDate(date) {
      // current date
      let today = new Date();
      let yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      let formattedToday = yyyy + "-" + mm + "-" + dd;

      // received date
      let rdate = moment(date).format("YYYY-MM-DD");
      if (rdate == formattedToday) {
        return "Today";
      } else {
        return rdate;
      }
    },
    getImgUrl(pic) {
      return require("../assets/styles/img/" + pic);
    },
    onFileChange(e) {
      // this.image = e.target.files[0];
      if (e.target.files[0]) {
        this.tdisabeld = true;
        this.bdisabled = false;
        this.image = e.target.files[0];
        this.text = e.target.files[0].name;
      } else {
        this.tdisabeld = false;
        this.bdisabled = true;
        this.image = "";
        this.text = "";
      }
      // this.imageSrc = URL.createObjectURL(file);
    },
    userDetail(id, name, refernceId, managementId, formid, pharmacyid, pageNum, skipLoader = false) {
      let self = this;
      self.activeId = id;

      // setting pharmacist data
      let pdata = {
        id: id,
        name: name,
        referenceid: refernceId,
        managementid: managementId,
        formid: formid,
        pharmacyid: pharmacyid,
      };
      self.$store.commit("setPharmacistData", pdata);

      let data = {};
      if (self.frompath == "home") {
        data = {
          formReferenceId: self.pdetails.referenceid,
          formsManagementId: self.pdetails.managementid,
          pageNo: "1",
        };
        // console.log("data from home", data);
        self.$store.commit("setName", name);
      } else {
        data = {
          formReferenceId: self.groupRequestDetails.formReferenceId,
          formsManagementId: self.groupRequestDetails.formsManagementId,
          pageNo: "1",
        };
        // console.log("data from past script request", data);
        self.$store.commit("setName", self.groupRequestDetails.pharmacyName);
      }
      if (pageNum) {
        data.pageNo = pageNum;
        self.pageNum = self.pageNum + 1;
      } else {
        self.pageNum = 2;
      }

      if (!skipLoader) {
        data.loading = true; // Show loader only if `skipLoader` is false
      } else {
        data.loading = false;
      }
      self.$store.dispatch("chatConversation", data).then((response) => {
        if (response.status == 200) {
          let responseData = response.data;
          // console.log("TYpe of data1",typeof responseData)
          let dates = [];
          responseData = responseData.reverse(function (x, y) {
            return x.time - y.time;
          });
          responseData.map((element) => {
            // console.log(element);
            Object.keys(element).forEach((key) => {
              if (key == "date" && dates.find((el) => el == element[key])) {
                element[key] = null;
              } else if (key == "date" && !dates.find((el) => el == element[key])) {
                dates.push(element[key]);
              }
            });
          });
          if (pageNum) {
            if (responseData.length > 0) {
              self.detailedChats = responseData.concat(self.detailedChats);
              dates = [];
              self.detailedChats.map((element) => {
                Object.keys(element).forEach((key) => {
                  if (key == "date" && dates.find((el) => el == element[key])) {
                    element[key] = null;
                  } else if (key == "date" && !dates.find((el) => el == element[key])) {
                    dates.push(element[key]);
                  }
                });
              });
            } else {
              self.noData = true;
            }
          } else {
            self.detailedChats = responseData;
            self.noData = false;
            setTimeout(() => {
              const element = document.getElementById("chat");
              const height = element.scrollHeight;
              element.scrollTo(0, height);
            }, 100);
          }
        } else {
        }
      });
    },
    onSubmit() {
      let self = this;
      self.tdisabeld = true;
      let data = {};
      let formData = new FormData();
      if (self.image) {
        formData.append("image", self.image);
        formData.append("is_load", true)
        this.text = "";
      } else {
        formData.append("is_load", false)
      }
      switch (self.frompath) {
        case "past-request-details":
        case "group-request-details":
          formData.append("formId", self.groupRequestDetails.formId);
          formData.append(
            "formsManagementId",
            self.groupRequestDetails.formsManagementId
          );
          formData.append("formReferenceId", self.groupRequestDetails.formReferenceId);
          formData.append("pharmacyId", self.groupRequestDetails.pharmacyId);
          formData.append("message", self.text);
          formData.append("pharmacyName", self.groupRequestDetails.pharmacyName);
          break;

        case "home":
          formData.append("formId", self.pdetails.formid);
          formData.append("formsManagementId", self.pdetails.managementid);
          formData.append("formReferenceId", self.pdetails.referenceid);
          formData.append("pharmacyId", self.pdetails.pharmacyid);
          formData.append("message", self.text);
          formData.append("pharmacyName", self.pdetails.name);
          break;

        default:
          break;
      }

      self.$store.dispatch("chatCreate", formData, self.image).then((response) => {
        if (response.status == 200) {
          self.$store.commit("setChatIdPayload", {
            formReferenceId: formData.get("formReferenceId"),
            formsManagementId: formData.get("formsManagementId"),
          });
          let find = self.chats.findIndex(
            (item) =>
              item.formsManagementId == formData.get("formsManagementId") &&
              item.formReferenceId == formData.get("formReferenceId")
          );
          // let find = self.chats.findIndex(item => (item.formManagementId == 1 && item.formReferenceId==1))
          if (find != -1) {
            console.log("find", find);
            self.chats[find].message = self.text;
          }
          self.text = "";
          self.image = "";

          self.userDetail(
            self.pdetails.id,
            self.pdetails.name,
            self.pdetails.referenceid,
            self.pdetails.managementid,
            self.pdetails.formid,
            self.pdetails.pharmacyid,
            null,
            true // Pass skipLoader = true
          );
          let data = {
            pageNo: self.pageNo,
            search: self.searchUser,
          };

          console.log(data)
          self.$store.dispatch("chatConversationList", data).then((response) => {
            if (response.status == 200) {
              self.$store.commit("setReceived", response.data);
            }
          });;
          console.log(response);
          self.tdisabeld = false;
        }
      });
    },
    scrollFunction(e) {
      console.log(e);
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollHeight - document.documentElement.scrollTop ===
          document.documentElement.clientHeight;
        if (bottomOfWindow) {
          console.log(bottomOfWindow);
        }
      };
    },
  },
  watch: {
    text(newValue, oldValue) {
      if (this.text.length > 0) {
        this.bdisabled = false;
        this.fdisabled = Boolean(this.image);
      } else {
        this.bdisabled = true;
        this.fdisabled = false;
      }
    },

    receivedMessage(newValue, oldValue) {
      let self = this;
      let responseData = JSON.parse(newValue);
      let dates = [];
      self.detailedChats = responseData.reverse(function (x, y) {
        return x.time - y.time;
      });

      responseData.map((element) => {
        // console.log(element);
        Object.keys(element).forEach((key) => {
          if (key == "date" && dates.find((el) => el == element[key])) {
            element[key] = null;
          } else if (key == "date" && !dates.find((el) => el == element[key])) {
            dates.push(element[key]);
          }
        });
      });
      self.detailedChats = responseData;
      if (newValue != oldValue) {
        self.initialChatLoad(false);
      }
    },
    received(newValue) {
      let self = this;
      let responseData = JSON.parse(newValue);
      self.chats = responseData;
    },
    frompath(newValue) {
      if (newValue == "past-request-details" || newValue == "group-request-details") {
        self.userDetail(
          self.pdetails.id,
          self.pdetails.name,
          self.pdetails.referenceid,
          self.pdetails.managementid,
          self.pdetails.formid,
          self.pdetails.pharmacyid
        );
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollFunction);
  },
};
</script>
